import type { EventsResponse, TransportUpdateResponse } from './types';

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Požadavek selhal (HTTP ${response.status}).`);
  }
  return (await response.json()) as T;
}

export function fetchEvents(options: { refresh?: boolean } = {}): Promise<EventsResponse> {
  return request<EventsResponse>(`/api/events${options.refresh ? '?refresh=1' : ''}`);
}

export function setTransport(
  eventId: string,
  userId: string,
  transport: boolean,
): Promise<TransportUpdateResponse> {
  return request<TransportUpdateResponse>(`/api/events/${encodeURIComponent(eventId)}/transport`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, transport }),
  });
}
